import { render, staticRenderFns } from "./MaskOverlayIndustry.vue?vue&type=template&id=20b21670&scoped=true"
import script from "./MaskOverlayIndustry.vue?vue&type=script&lang=js"
export * from "./MaskOverlayIndustry.vue?vue&type=script&lang=js"
import style0 from "./MaskOverlayIndustry.vue?vue&type=style&index=0&id=20b21670&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20b21670",
  null
  
)

export default component.exports